import { render, staticRenderFns } from "./jefeszonaM.vue?vue&type=template&id=4541c7f6"
import script from "./jefeszonaM.vue?vue&type=script&lang=js"
export * from "./jefeszonaM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports